import { render, staticRenderFns } from "./profile-nav.vue?vue&type=template&id=59ef38db&"
import script from "./profile-nav.vue?vue&type=script&lang=js&"
export * from "./profile-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports